import deepEqual from "deep-equal";

export default function useHasChanges({ initialValues, values }) {
  console.log('Diff', initialValues, values);
  if (!values) {
    return false;
  }
  return !deepEqual(initialValues, values, { strict: false });
};
